import { render } from "./SiteConfig.vue?vue&type=template&id=507e1f02&scoped=true"
import script from "./SiteConfig.vue?vue&type=script&lang=js"
export * from "./SiteConfig.vue?vue&type=script&lang=js"

import "./SiteConfig.vue?vue&type=style&index=0&id=507e1f02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507e1f02"]])

export default __exports__